import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { ContractsMain } from '../../organisms/settings/contracts/ContractsMain';

/**
 * presentations/components/pages/settings/ContractsPage.tsx
 */
const ContractsPage: React.FC = () => (
  <SettingsAccessControl allowedRoles='creditViewer'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />
      <SettingsWrapper>
        <ContractsMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default ContractsPage;
